module.exports = __webpack_public_path__ + "static/img/activity-20240620.671b96d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-20240620.png
// module id = 87/P
// module chunks = 0